import { useEffect, useState } from "react"
import { WorkAssignByOfficialsAPI } from "../../../../../Redux/WorkAssignByOfficialsSlice/WorkAssignByOfficialsSlice"
import { useAuthState } from "../../../../../Helper/Context";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { PopUpWorkAssign } from "./PopUp/PopUpWokAssign";
import { Loading } from "../../../../../Helper/Loading";
import { ExportWorkAssignByOfficialsN } from "./ExportWorkAssignByOfficialsN";

export const WorkAssignByOfficialsN = (props) => {
    const { Month, FinancialYear, AssetID, ActiveBtn,M_WardID,WorkType } = props
    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [OpenModal, setOpenModal] = useState(false);
    const [Flag, setFlag] = useState("");
    const [officerData, setOfficerData] = useState(null)

    const [heading, setHeading] = useState('')
    const [fromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
    const [workAssignID, setWorkAssignID] = useState(null)
    const [Isclear, setIsClear] = useState(false)



    const handlePopupOpen = (data, flag, heading, count) => {
        if (count) {
            setOfficerData(data)
            setFlag(flag)
            setOpenModal(true);
            setHeading(heading)
            setWorkAssignID(data?.assingByM_UserID)
        }
    };

    const handleClear = () => {
        setIsClear(!Isclear)
        setFromDate("")
        setToDate('')
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const Tabledata = [
        {

            "Heading": [
                {
                    "head": "Designation",
                },
                {
                    "head": "Officer  Name",
                },
                {
                    "head": "Ward",
                },
                {
                    "head": "Total Assign Works",
                },
                {
                    "head": "Total works Completed",
                },
                {
                    "head": "Total pending works",
                },
                {
                    "head": "0 to 7 days",
                },
                {
                    "head": "7 to 15 days",
                },
                // {
                //     "head": "Completed",
                // },
                {
                    "head": "15 to 30 days",
                },
                {
                    "head": "30 to 90 days",
                },
                {
                    "head": "90 to 180 days",
                },
                {
                    "head": "1 year",
                },


            ],

        }
    ]

    useEffect(() => {
        const data = {
            FromDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : "",
            ToDate: toDate ? moment(toDate).format('YYYY-MM-DD') : "",
            M_WorkTypeID: 0,
            M_ZoneID: 0,
            M_WardID: 0,
            M_AssetTypeID: AssetID,
            M_WorkTypeID: 0,
            M_UserID: UserID,
            Flag: "Officer",
            token: token,

        }
        dispatch(WorkAssignByOfficialsAPI({ data }))
    }, [fromDate, toDate, Isclear])

    const { tableData, isLoading } = useSelector(state => state.Get_WEB_GD_OfficerWisePendingWorkStatus_SelectData)


    return (
        <>
            {isLoading && <Loading />}
            <div className='row m-0 p-0 pt-2  bg-white' style={{ border: '1px solid #0d467ee6', borderRadius: '8px ', width: '100%', overflow: 'scroll' }}>

                <div className="col-12 col-lg-6 ps-lg-4">

                    <div className="row">
                        <div className="col-12 col-lg-6">
                            <label className="d-block" htmlFor="fromDate"><b>From Date : </b></label>
                            <input type="date" className="form-control" id="fromDate" value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)} />
                        </div>
                        <div className="col-12 col-lg-6">
                            <label className="d-block" htmlFor="toDate"><b>To Date : </b></label>
                            <input type="date" className="form-control" id="toDate" value={toDate}
                                onChange={(e) => setToDate(e.target.value)} />
                        </div>
                    </div>
                </div>

                <div className="col-12 col-lg-6 d-flex align-items-end ">
                    <div className="">
                        <button onClick={() => handleClear()} type="button" className="btn active_group_btn mr-1  ml-1 px-3" > Clear</button>
                        {/* <button type="button" className="btn text-white mr-1  ml-1" style={{ background: '#048a8b' }}> Export</button> */}
                        <ExportWorkAssignByOfficialsN
                            tableData={tableData}
                            name={ActiveBtn}
                            Tabledata={Tabledata}
                            fromDate={fromDate}
                            toDate={toDate}
                        />
                    </div>
                </div>

                <div className="col-12 pt-3 pb-0 m-1">
                    <table id="totalordergenerated"
                        cellPadding="0"
                        cellSpacing="0"
                        border="0"
                        className="table table-bordered " style={{ textAlign: "center" }}>
                        <thead className="gardenworktable" id="customers">
                            <tr className="text-center tablethhead " style={{ width: '100%' }}>
                                {
                                    Tabledata && Tabledata[0]?.Heading.map((j) => {
                                        return (
                                            <th className="text-center fw-bold  py-2" style={{ whiteSpace: 'nowrap' }}>{j.head}</th>
                                        )
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {tableData?.map((designation) => {
                                return designation.rowdata?.map((officer, officerIndex) => {
                                    const rowSpan = designation.rowdata?.length || 1;
                                    return (
                                        <tr
                                            className="text-center"
                                            key={`${designation.designation}-${officerIndex}`}
                                        >
                                            {officerIndex === 0 ? (
                                                <td className="text-center" rowSpan={rowSpan}>{designation.designation}</td>
                                            ) : null}

                                            <td style={{ whiteSpace: "nowrap" }}>{officer.employeeName}</td>
                                            <td>{officer.wardName}</td>
                                            {/* Pending , 0_7DaysCount , 7_15DaysCount,15_30DaysCount , 30_90DaysCount, 90_180DaysCount , 365DaysCount,Completed,All, */}
                                            <td
                                                onClick={() => handlePopupOpen(officer, "All", "Total Assign Works", officer?.totalAllCount,)} className="bluecolorCount text-center">
                                                 <span className={officer.totalAllCount > 0 ? "cursor-pointer_bg" : "cursor-none"}>{officer.totalAllCount}</span>
                                            </td>

                                            <td
                                                onClick={() => handlePopupOpen(officer, "Completed", "Total works Completed", officer?.completedCount)} className="greencolorCount text-center">
                                                 <span className={officer.completedCount > 0 ? "cursor-pointer_bg":"cursor-none"}>{officer.completedCount}</span>
                                            </td>

                                            <td
                                                onClick={() => handlePopupOpen(officer, "Pending", "Total pending works", officer?.pendingCount)} className="orangecolorCount text-center">
                                                 <span className={officer.pendingCount>0 ? "cursor-pointer_bg" : "cursor-none"}>{officer.pendingCount}</span>
                                            </td>

                                            <td
                                                onClick={() => handlePopupOpen(officer, "0_7DaysCount", "0 to 7 days", officer?.pending_0_7DaysCount)} className="bluecolorCount text-center">
                                                 <span className={officer.pending_0_7DaysCount > 0?"cursor-pointer_bg" : "cursor-none"}>{officer.pending_0_7DaysCount}</span>
                                            </td>

                                            <td
                                                onClick={() => handlePopupOpen(officer, "7_15DaysCount", "7 to 15 days", officer?.pending_7_15DaysCount)} className="greencolorCount text-center">
                                                 <span className={officer.pending_7_15DaysCount >0 ? "cursor-pointer_bg" : "cursor-none"}>{officer.pending_7_15DaysCount}</span>
                                            </td>

                                            <td
                                                onClick={() => handlePopupOpen(officer, "15_30DaysCount", "15 to 30 days", officer?.pending_15_30DaysCount)} className="orangecolorCount text-center">
                                                 <span className={officer.pending_15_30DaysCount >0 ? "cursor-pointer_bg" : "cursor-none"}>{officer.pending_15_30DaysCount}</span>
                                            </td>

                                            <td
                                                onClick={() => handlePopupOpen(officer, "30_90DaysCount", "30 to 90 days", officer?.pending_30_90DaysCount)} className="bluecolorCount text-center">
                                                 <span className={officer.pending_30_90DaysCount > 0 ? "cursor-pointer_bg" : "cursor-none"}>{officer.pending_30_90DaysCount}</span>
                                            </td>

                                            <td
                                                onClick={() => handlePopupOpen(officer, "90_180DaysCount", "90 to 180 days", officer?.pending_90_180DaysCount)} className="greencolorCount text-center">
                                                 <span className={officer.pending_90_180DaysCount>0 ?"cursor-pointer_bg" : "cursor-none"}>{officer.pending_90_180DaysCount}</span>
                                            </td>
                                            
                                            <td
                                                onClick={() => handlePopupOpen(officer, "365DaysCount", "1 year", officer?.pending_365DaysCount)} className="orangecolorCount text-center">
                                                 <span className={officer.pending_365DaysCount >0 ? "cursor-pointer_bg" : "cursor-none"}>{officer.pending_365DaysCount}</span>
                                            </td>

                                        </tr>
                                    );
                                });
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            {OpenModal &&
                <PopUpWorkAssign
                    handleOpenModal={handlePopupOpen}
                    ApiFlag={Flag}
                    handleCloseModal={handleCloseModal}
                    officerData={officerData}
                    FinancialYear={FinancialYear}
                    Month={Month}
                    M_AssetTypeID={AssetID}
                    heading={heading}
                    WorkAssignByM_UserID={workAssignID}
                    toDate={toDate}
                    fromDate={fromDate}
                    GridFlag = "Officer"
                />
            }
        </>
    )
}